import Util from '../RegistrationUtil'
import Field from '../RegistrationField'

function Email(opts) {
    Field.call(this, opts)

    this.$input = this.$html.find('input')
}

Util.inherit(Email, Field, {
    getClassName: function() {
        return 'textbox email'
    },

    buildHtml: function() {
        return (
            '<input type="email" ' +
            this._getPlaceholderText() +
            ' ' +
            this._getAltText() +
            '  id="' +
            this._getId() +
            '" />'
        )
    },

    applyBindings: function() {
        var self = this

        this.$input.on('change', function() {
            self.setValue($(this).val())
        })
        this.$input.on('focus', this.focus.bind(this))
        this.$input.on('blur', this.blur.bind(this))
    },

    updateView: function() {
        Field.prototype.updateView.call(this)
        this.$input.val(this.value)
    },

    isEmailValid: function() {
        var email = this.getValue()

        return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)
    },
})

export default Email
